module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/$.html.js
 ** module id = 246
 ** module chunks = 0
 **/